import { useFlag } from '@bestseller/retail-planning.launchdarkly';
import { Box } from '@mui/material';
import { FC } from 'react';
import { useChain } from 'src/hooks/chain/useChain';
import { StoreDetails } from 'src/hooks/turnover/useTurnoverDetails';
import { StoreModel } from 'src/infrastructure/rest-api/api-types';
import { StoreInfo } from '../StoreInfo/StoreInfo';

interface Props {
    store?: StoreModel;
    partner?: string | null;
    currency?: string | null;
}
export const StoreInfoContainer: FC<Props> = ({ store, partner, currency }) => {
    const partnerName = store?.operationalResponsible?.name ?? partner;
    const chain = useChain();
    const cluster = store?.cluster?.name;
    const country = store?.country?.name;

    return (
        <Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 4,
            }}
        >
            {chain && <StoreInfo title="Chain" content={chain} />}
            {country && <StoreInfo title="Country" content={country} />}
            {partnerName && partnerName !== '?' && <StoreInfo title="Partner" content={partnerName} />}
            {cluster && <StoreInfo title="Cluster" content={cluster} />}
            {currency && <StoreInfo title="Currency" content={currency} />}
        </Box>
    );
};
interface TurnoverStoreInfoContainerProps {
    chain: string | undefined;
    currency: string | undefined | null;
    storeDetails: StoreDetails;
}

export const TurnoverStoreInfoContainer: FC<TurnoverStoreInfoContainerProps> = ({ chain, currency, storeDetails }) => {
    const hideDeprecatedFields = useFlag('hideDeprecatedFields');

    return (
        <Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                rowGap: 1,
                columnGap: 4,
            }}
        >
            {!hideDeprecatedFields &&
                (storeDetails?.storeType === 'WHOLESALE' || storeDetails?.operationalResponsibleName !== '?') && (
                    <StoreInfo
                        title="Primary Partner"
                        content={
                            storeDetails.storeType === 'WHOLESALE'
                                ? storeDetails.businessTradingPartnerName
                                : (storeDetails.operationalResponsibleName ?? '')
                        }
                    />
                )}
            {!hideDeprecatedFields && <StoreInfo title="Area Manager" content={storeDetails.areaManagerName ?? ''} />}
            <StoreInfo title="Opening Date" content={storeDetails.storeOpeningDateFormatted ?? ''} />
            <StoreInfo title="Country" content={storeDetails.countryName ?? ''} />
            <StoreInfo title="Chain" content={chain ?? ''} />
            {currency && <StoreInfo title="Currency" content={currency ?? ''} />}
        </Box>
    );
};
